import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue';
import BaseModal from '@lmt-rpb/BaseModal/BaseModal.vue';
import ReviewBoxHeader from './internals/ReviewBoxHeader.vue';
import ReviewBoxModalContent from './internals/ReviewModalContent.vue';
import type { ReviewType } from '@/interfaces/review-types';

interface Props {
	review: ReviewType;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewBox',
  props: {
    review: {}
  },
  emits: ['show-detail-review'],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

const modalRef = ref<typeof BaseModal | null>(null);

const showReviewModal = () => {
	emit('show-detail-review');
	modalRef.value?.openModal();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "review-box-list-item",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (showReviewModal()))
  }, [
    _createVNode(ReviewBoxHeader, {
      class: "review-box-list-item__header",
      review: _ctx.review
    }, null, 8 /* PROPS */, ["review"]),
    _createVNode(BaseModal, {
      ref_key: "modalRef",
      ref: modalRef,
      class: "review-box-modal",
      "header-title": "Bewertung",
      "with-open-button": "",
      "open-button-props": { label: 'Mehr lesen', withIcon: false, class: 'review-box-list-item__button' },
      onOpen: _cache[0] || (_cache[0] = ($event: any) => (emit('show-detail-review')))
    }, {
      default: _withCtx(() => [
        _createVNode(ReviewBoxModalContent, { review: _ctx.review }, null, 8 /* PROPS */, ["review"])
      ]),
      _: 1 /* STABLE */
    }, 512 /* NEED_PATCH */)
  ]))
}
}

})